import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AdminUsersComponent } from 'src/app/components/admin-users/admin-users.component';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.css']
})
export class AlertDialogComponent implements OnInit, OnDestroy {
  title: string;
  mainActionText: string;
  dataSource: any;

  constructor(public dialogRef: MatDialogRef<AdminUsersComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.title = this.data.title;
    this.dataSource = this.data.alertStr;
    this.mainActionText = this.data.mainAction;
  }

  ngOnDestroy() {
  }

  public okClicked() {
    this.dialogRef.close(this.data.mainAction);
  }
  
  public closeClicked() {
    this.dialogRef.close('Cancel');
  }
}
